import gql from 'graphql-tag';

export const LOCATION_SETUP_FRAGMENT = gql`
	fragment locationSetup on LocationSetup {
		id
		bookTransport
		sendEmail
		setupTeamUpdate
		status
		orderNumber
		identifier
		deliveryContact {
			id
			destroyed
			name
			email
			phoneNumber
			role
		}
		location {
			id
			name
			destroyed
			addressObj {
				id
				region
				street
				city
				postcode
			}
			client {
				id
				name
			}
		}
		machineSetups {
			id
			status
			identifier
			movePlanId
			moveSourceLocation {
				id
				name
			}
			moveSourcePlace {
				id
				name
			}
			machineModel {
				id
				name
			}
			place {
				id
				name
			}
			machine {
				id
				assetId
			}
			plannedMachine {
				id
				assetId
			}
		}
		marketSetups {
			id
			status
			identifier
			marketType
			place {
				id
				name
			}
			machine {
				id
				assetId
			}
			plannedMachine {
				id
				assetId
			}
		}
		created
		creator {
			id
			firstname
			lastname
			username
		}
		dueDate
		subscribers {
			id
			firstname
			lastname
			username
		}
	}
`;

export const CREATE_LOCATION_SETUP = gql`
    mutation createLocationSetupMutation($input: CreateLocationSetupInput!) {
        createLocationSetup(input: $input) {
            ...locationSetup
        }
	}
	${LOCATION_SETUP_FRAGMENT}
`;

export const GET_LOCATION_SETUPS = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: LocationSetupPageFilter
	) {
		getLocationSetups(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...locationSetup
			}
			count
		}
	}
	${LOCATION_SETUP_FRAGMENT}
`;

export const GET_LOCATION_SETUPS_COUNT = gql`
	query {
		countLocationSetups
	}
`;

export const DESTROY_LOCATION_SETUP = gql`
	mutation destroyLocationSetupMutation ($id: ID!) {
		destroyLocationSetup(id: $id)
	}
`;


export const GET_LOCATION_SETUP = gql`
	query($id: String) {
		getLocationSetup(id: $id) {
			...locationSetup
		}
	}
	${LOCATION_SETUP_FRAGMENT}
`;

export const MODIFY_LOCATION_SETUP = gql`
	mutation modifyLocationSetupMutation($input: ModifyLocationSetupInput!) {
		modifyLocationSetup(input: $input) {
			locationsetup {
				...locationSetup
			}
		}
	}
	${LOCATION_SETUP_FRAGMENT}
`;
